import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import ArticleItem from './ArticleItem';
import './Articles.css';

const articles = [
  {
    image: '/images/article_backgrounds/gan.jpg',
    title: 'Generative Adversarial Networks: A Rival Makes You Stronger',
    link: 'https://medium.com/analytics-vidhya/generative-adversarial-networks-a-rival-makes-you-stronger-d0b2aa87e06c',
    tags: 'ML',
  },
  {
    image: '/images/article_backgrounds/abstractive_text.jpg',
    title: 'Abstractive Text Summarization',
    link: 'https://medium.com/@soum1071/abstractive-text-summarization-33edf197a54c',
    tags: 'Python / NLP / DL',
  },
  {
    image: '/images/article_backgrounds/tensorflow.jpg',
    title: 'Tensorflow: Hello World',
    link: 'https://medium.com/@soum1071/tensorflow-hello-world-9320004cfa9f',
    tags: 'Python / Tensorflow',
  },
];

function Articles() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section id="articles" className="articles" ref={ref}>
      <div className="articles__inner">
        <div style={{ textAlign: 'center' }}>
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            style={{ position: 'relative', left: 'auto', transform: 'none', display: 'inline-block' }}
          >
            ./Articles
          </motion.h2>
          <motion.div
            className="section-title-underline"
            initial={{ scaleX: 0 }}
            animate={isInView ? { scaleX: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.3, type: 'spring', stiffness: 200, damping: 20 }}
            style={{ transformOrigin: 'center' }}
          />
        </div>

        <ul className="articles__grid">
          {articles.map((article, i) => (
            <motion.div
              key={article.title}
              initial={{ opacity: 0, scale: 0.9, filter: 'blur(8px)' }}
              animate={isInView ? { opacity: 1, scale: 1, filter: 'blur(0px)' } : {}}
              transition={{ duration: 0.7, delay: 0.2 + 0.15 * i, ease: [0.4, 0, 0.2, 1] }}
            >
              <ArticleItem
                image_src={article.image}
                title={article.title}
                link={article.link}
                tags={article.tags}
              />
            </motion.div>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default Articles;
